import "./index.scss";
import React from "react";

const PressCard = ({ article, inSlider = false }) => {
  const {
    media,
    date,
    headline,
    externalLink
  } = article;

  return (
    <div className="col-lg-3">
      <a className="press__external-link" href={externalLink} target="_blank" rel="noreferrer">
        <div className={`press-card ${inSlider ? 'press-card--slider' : null}`}>

          <span className="press__media">{media}</span>
          <span className="press__date">{date}</span>
          <h6 className="press__headline oblique">{headline}</h6>
          <a className="press__external-link" href={externalLink} target="_blank" rel="noopener noreferrer">Go to article ›</a>

        </div>
      </a>
    </div>
  )
}

export default PressCard;